import { Reveal, SectionTag } from "./shared";

const companies = [
  { name: "Automotive Parts", revenue: "$52.0M", identified: "$6.2M", realized: "$4.9M", rate: "79%" },
  { name: "Beverage Producer", revenue: "$511.0M", identified: "$29.7M", realized: "$24.2M", rate: "81%" },
  { name: "Computer Hardware", revenue: "$1.97B", identified: "$150M", realized: "$98.6M", rate: "65%" },
];

const rows = [
  ["Revenue", "revenue"],
  ["Trapped Cash Identified", "identified"],
  ["Realized in 90 Days", "realized"],
  ["Recovery Rate", "rate"],
];

export const Proof = () => (
  <section id="proof" className="py-12 lg:py-16 bg-[#0B1B2B] relative overflow-hidden" data-testid="proof-section">
    <div className="absolute inset-0 dot-grid-dark pointer-events-none" />
    <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10">
      <SectionTag num="06" label="Portfolio Proof" light />
      <Reveal>
        <h2 className="font-display font-extrabold text-white tracking-[-0.02em] leading-[1.05] text-3xl sm:text-4xl lg:text-[44px] max-w-[720px]">
          Actual <span className="text-[#7fd6b8]">portfolio results.</span>
        </h2>
        <p className="mt-4 text-white/70 text-sm italic" data-testid="nda-note">Client names withheld under NDA.</p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-10 hidden md:block rounded-2xl border border-white/10 overflow-x-auto" data-testid="proof-table">
          <table className="w-full min-w-[640px] text-left">
            <thead>
              <tr className="bg-white/[0.06]">
                <th className="py-5 px-6 text-[12px] uppercase tracking-[0.16em] text-white/70 font-bold w-[240px]"></th>
                {companies.map((c) => (
                  <th key={c.name} className="py-5 px-6 font-display font-bold text-white text-[16px]">{c.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map(([label, key], ri) => (
                <tr key={key} className={`border-t border-white/8 ${ri === rows.length - 1 ? "bg-[#0E5F46]/25" : ""}`}>
                  <td className="py-5 px-6 text-white/75 text-sm font-semibold">{label}</td>
                  {companies.map((c) => (
                    <td key={c.name} className={`py-5 px-6 font-display font-extrabold text-xl lg:text-2xl tracking-[-0.01em] ${ri === rows.length - 1 ? "text-[#7fd6b8]" : "text-white"}`}>
                      {c[key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Reveal>

      <div className="mt-8 md:hidden space-y-4" data-testid="proof-cards-mobile">
        {companies.map((c, ci) => (
          <Reveal key={c.name} delay={0.06 * ci}>
            <div className="rounded-2xl bg-white/[0.05] border border-white/10 p-6" data-testid={`proof-card-${ci + 1}`}>
              <h3 className="font-display font-bold text-white text-lg">{c.name}</h3>
              <dl className="mt-4 space-y-3">
                {rows.map(([label, key], ri) => (
                  <div key={key} className={`flex items-center justify-between gap-4 ${ri === rows.length - 1 ? "pt-3 border-t border-white/10" : ""}`}>
                    <dt className="text-white/75 text-sm font-semibold">{label}</dt>
                    <dd className={`font-display font-extrabold text-xl ${ri === rows.length - 1 ? "text-[#7fd6b8]" : "text-white"}`}>{c[key]}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-10 grid md:grid-cols-3 gap-4">
        {[
          ["$185.9M", "identified across the portfolio"],
          ["$127.7M", "realized in 90-day timelines"],
          ["68%", "average portfolio recovery"],
        ].map(([num, label], i) => (
          <Reveal key={num} delay={0.08 * i}>
            <div className="p-7 rounded-2xl bg-white/[0.05] border border-white/10 text-center" data-testid={`proof-aggregate-${i + 1}`}>
              <p className="font-display font-extrabold text-[#7fd6b8] text-4xl tracking-[-0.02em]">{num}</p>
              <p className="mt-2 text-white/75 text-sm">{label}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-8 text-white/75 text-sm text-center max-w-[640px] mx-auto leading-relaxed">
          Each diagnostic: 7 days. Each company: $25,000 fixed. Zero organizational disruption.
          See the full diagnostic presentation for the deep dive on each case and the framework methodology.
        </p>
      </Reveal>
    </div>
  </section>
);
